const licenseLocalNumbers = [
    { label: '서울(11)', value: 11 },
    { label: '부산(12)', value: 12 },
    { label: '경기(13)', value: 13 },
    { label: '강원(14)', value: 14 },
    { label: '충북(15)', value: 15 },
    { label: '충남(16)', value: 16 },
    { label: '전북(17)', value: 17 },
    { label: '전남(18)', value: 18 },
    { label: '경북(19)', value: 19 },
    { label: '경남(20)', value: 20 },
    { label: '제주(21)', value: 21 },
    { label: '대구(22)', value: 22 },
    { label: '인천(23)', value: 23 },
    { label: '대전(25)', value: 25 },
    { label: '울산(26)', value: 26 },
]

export {
    licenseLocalNumbers
}
